import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    tokenelgocho: "",
    adminelgocho: []
  },
  mutations: {
    login(state, data) {
      state.adminelgocho = data.user;
      state.tokenelgocho = data.token;
    },
    logout(state) {
      state.sesion = [];
      state.adminelgocho = [];
      state.tokenelgocho = "";
    },
    adminelgocho(state, data) {
      state.adminelgocho = data;
    }
  },
  actions: {
    login({ commit }, data) {
      commit("login", data);
    },
    logout({ commit }) {
      commit("logout");
    },
    setuser({ commit }, data) {
      commit("adminelgocho", data);
    }
  }
});
